module.exports = __webpack_public_path__ + "img/20211013.d82498a4.png";